export default "__VITE_ASSET__DQ80yAGC__"